module.exports = __webpack_public_path__ + "static/media/36.2465b514.jpg";